import { IconPlus16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { ControlButton } from '../../../../../common/components/ControlButton';

export interface IZoomInButtonProps {
  onZoomIn(): void;
  onClick(): void;
}

export const ZoomInButton: React.FC<IZoomInButtonProps> = props => {
  const { onZoomIn, onClick } = props;

  const handleZoomInClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault();
      onClick();
      onZoomIn();
    },
    [onZoomIn, onClick],
  );

  return (
    <ControlButton className={styles['button']} onClick={handleZoomInClick} size="M">
      <IconPlus16 color="icon-primary-default" />
    </ControlButton>
  );
};
